/**
 * ClipboardUtil - I put things on the clipboard. ONLY concerned with that hand-off - what goes on
 * it is the caller's.
 */
export const ClipboardUtil = {
  /**
   * One clipboard entry can carry the same content under two flavours and let the paste target
   * choose, so a rich copy is not formatted *or* unformatted - both go. Leave `html` out and the
   * plain flavour goes alone, which is what a plain copy and a markup-as-source copy both want.
   *
   * Without `ClipboardItem` only `writeText` is available, which loses the formatting. Both paths
   * need a secure context; localhost counts.
   */
  async copy({ html, text }: { html?: string | null; text: string }) {
    if (!html || typeof ClipboardItem === 'undefined') {
      await navigator.clipboard.writeText(text);

      return;
    }

    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([text], { type: 'text/plain' }),
      }),
    ]);
  },
};
